<template lang="pug">
div.wrap-trainer-report-list
  div.sub-header
    div.sub-header-content
      v-select(v-model="filter" :items="['全て', '担当レポート']" dark)
  ItemTrainerReportCard(v-for="item in filteredReports", :content="item")
</template>

<style lang="scss" scoped>
.wrap-trainer-report-list {
  width: 100%;
  min-height: 100vh;
  padding-top: 48px;
  .sub-header {
    width: 100%;
    border-bottom: solid 0.8px rgba(0, 0, 0, 0.6);
    background: #2a2a2a;
    .sub-header-content {
      width: 93%;
      max-width: 420px;
      margin: 0 auto;
    }
  }
}
</style>

<style lang="scss">
.v-input {
  margin: 0 !important;
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import ItemTrainerReportCard from '@/components/item/ItemTrainerReportCard'
import { database } from '@shared/database'

export default {
  components: {
    ItemTrainerReportCard
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  props: {
    trainer: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      reports: [],
      filteredReports: [],
      filter: '担当レポート'
    }
  },
  watch: {
    filter: function () {
      this.updateFilteredReports()
    },
    reports: function () {
      this.updateFilteredReports()
    }
  },
  async created () {
    // db.collection('REPORTS')
    //   // .where('trainer', '==', this.trainer.trainerId)
    //   .orderBy('updatedAt', 'desc')
    //   .onSnapshot(this.handleReports)
    database.onReportsUpdated({}, this.handleReports)
  },
  methods: {
    ...mapActionsAuth(['signOut']),
    onLoggedIn () {
      
    },
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    },
    handleReports (reports) {
      this.reports = reports
    },
    updateFilteredReports () {
      switch (this.filter) {
        case '担当レポート':
          this.filteredReports = this.reports.filter(report => {
            return report.trainer === this.trainer.trainerId
          })
          break
        case '全て':
          this.filteredReports = this.reports
          break
      }
    }
  }
}
</script>
